import RolesEnum from "../Enum/RolesEnum";

const loadUserFromStorage = () => {
  const user = localStorage.getItem(process.env.REACT_APP_PROFILE);
  return user ? JSON.parse(user) : {};
}

export const getUser = () => loadUserFromStorage();

export const isResale = () => {
  const resaleRoles = [RolesEnum.Resale, RolesEnum.FuncionarioRevenda, RolesEnum.Organizacao];
  const user = loadUserFromStorage()
  return resaleRoles.includes(user.role)
}

export const isUserResale = () => {
  const user = loadUserFromStorage()
  return user.role === RolesEnum.FuncionarioRevenda
}

export const isBackOffice = () => loadUserFromStorage().role === RolesEnum.BackOffice

export const isUpgasEmployee = () => loadUserFromStorage().role === RolesEnum.FuncionarioUpgas

export const isBackOfficeOrUpgasEmployee = () => isBackOffice() || isUpgasEmployee()

export const isOrganization = () => loadUserFromStorage().role === RolesEnum.Organizacao
